import Vue from 'vue'

import Multiselect from 'vue-multiselect'

Vue.component('multiselect', Multiselect)



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/vue-multiselect.js